import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Clock, FileText } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-primary pt-8 pb-10 md:pt-20 md:pb-24 px-4 overflow-hidden" data-id="element-73">
      <div className="max-w-6xl mx-auto" data-id="element-74">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-75">
          {/* Text Content */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left order-2 md:order-1" data-id="element-76">
            <p className="text-coral font-semibold tracking-wide text-xs md:text-base uppercase mb-3 md:mb-4" data-id="element-77">
              Para mamás que ya no quieren pelear por el celular
            </p>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-text-primary leading-tight mb-4 md:mb-6" data-id="element-78">
              Celular bajo control, <br className="hidden md:block" data-id="element-79" />
              <span className="italic text-trust" data-id="element-80">hogar en paz</span>
            </h1>

            <p className="text-base md:text-xl text-text-secondary mb-6 md:mb-8 max-w-lg leading-relaxed" data-id="element-81">
              El plan de 30 días para poner límites sin gritos y recuperar la
              conexión con tu adolescente.
            </p>

            <div className="w-full max-w-md md:max-w-none flex flex-col items-center md:items-start" data-id="element-82">
              <CTAButton className="w-full md:w-auto mb-3 md:mb-4" data-id="element-83" />

              <div className="flex flex-wrap justify-center md:justify-start gap-3 md:gap-4 text-xs md:text-sm text-text-secondary font-medium" data-id="element-84">
                <div className="flex items-center gap-1.5" data-id="element-85">
                  <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-trust" data-id="element-86" />
                  <span data-id="element-87">Descarga inmediata</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-88">
                  <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-trust" data-id="element-89" />
                  <span data-id="element-90">Formato PDF</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-91">
                  <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-success" data-id="element-92" />
                  <span data-id="element-93">Garantía de 7 días</span>
                </div>
              </div>
            </div>
          </div>

          {/* Image Content */}
          <div className="order-1 md:order-2 flex justify-center relative" data-id="element-94">
            <div className="absolute inset-0 bg-coral/5 rounded-full blur-3xl transform scale-150 -z-10" data-id="element-95"></div>
            <img src="https://cdn.magicpatterns.com/uploads/h78tCJ2b46bbpyXU1hyyLc/portada.png" alt="Portada del libro Celular bajo control, hogar en paz" className="w-full max-w-[220px] md:max-w-[400px] h-auto object-contain drop-shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-96" />
          </div>
        </div>
      </div>
    </section>;
}